import Router from 'vue-router';
import config from '@/config';
import { middlewarePipeline } from '@/router/helpers';
import routes from '@/router/routes';

export const createRouter = (store) => {
  const router = new Router({
    mode: 'history',
    base: config.baseUrl,
    routes: routes(store),
    scrollBehavior() {
      if (document.getElementById('app-body')) {
        document.getElementById('app-body').scrollTop = 0;
      }
      return ({ x: 0, y: 0 });
    },
  });

  router.beforeEach((to, from, next) => {
    if (!to.meta.middleware) {
      return next();
    }

    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];

    const context = {
      to,
      from,
      next,
      redirect: next,
    };

    return middleware[0]({
      ...context,
      next: middlewarePipeline(context, middleware, 1),
    });
  });

  return router;
};
